import { render } from "./UploadButtonComponent.vue?vue&type=template&id=6f80433c&scoped=true"
import script from "./UploadButtonComponent.vue?vue&type=script&lang=js"
export * from "./UploadButtonComponent.vue?vue&type=script&lang=js"

import "./UploadButtonComponent.vue?vue&type=style&index=0&id=6f80433c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f80433c"]])

export default __exports__